import React from "react";
import { ReferralModal } from "./referralModal";

const ReferralModalDara = () => {
  const { Title, Text, CloseButton } = ReferralModal;
  return (
    <ReferralModal referralType="partner">
      <Title>Just for being a friend of a friend.</Title>
      <Text>
        <strong>Get 1 month of Mangomint on us,</strong> including onboarding support and (free!) data transfer. Book a
        demo to speak with our team.
      </Text>
      <CloseButton>Sounds good!</CloseButton>
    </ReferralModal>
  );
};

export { ReferralModalDara };
